import { RegItem, RegItemType } from 'src/types/regItem'
import {
  CashFundDetails,
  ExternalRegistryDetails,
  GiftCardDetails,
  GroupGiftDetails,
  HelpAndFavorDetails,
  ProductDetails,
} from './variants'

export const getRegItemDetailsComponent = (regItem: Partial<RegItem>) => {
  const regItemType: RegItemType | undefined = regItem.itemType

  switch (regItemType) {
    case 'cash_fund':
      return CashFundDetails
    case 'electronic_gift_card':
      return GiftCardDetails
    case 'external_registry':
      return ExternalRegistryDetails
    case 'favor':
      return HelpAndFavorDetails
    case 'group_gift':
      return GroupGiftDetails
    case 'product':
      return ProductDetails
    default:
      return ProductDetails
  }
}
